export default function () {
  let offset = 0;
  const additionalOffset = 50; // Change this value to the number of pixels you want above the element

  /**
   * Scroll down to anchor on page load
   */
  $(window).on("load", () => {
    if ($(window).width() > 1240) {
      offset = $(".o-header").outerHeight();
    } else {
      offset = $(".o-mobileHeader").outerHeight() + 30;
    }

    if ($(location.hash).length > 0) {
      scrollToElement($(location.hash), offset + additionalOffset);
    }
    anchorlink();
  });

  /**
   * Scroll down to anchor on click link
   */
  $(document).on("click", 'a[href^="#"]', function (e) {
    e.preventDefault();

    const href = $.attr(this, "href");

    if ($(href).length > 0) {
      scrollToElement($(href), offset + additionalOffset, () => {
        window.history.pushState(null, null, href);
      });
    }
  });
}

export function scrollToElement($element, offset = 0, callback) {
  $("html, body").animate(
    {
      scrollTop: $element.offset().top - offset,
    },
    500,
    function () {
      if (typeof callback === "function") {
        callback();
      }
    }
  );
}

function anchorlink() {
  const additionalOffset = 50; // Change this value to the number of pixels you want above the element

  // The function actually applying the offset
  function offsetAnchor() {
    if (location.hash.length !== 0) {
      const $target = $(location.hash);
      if ($target.length) {
        const offset = ($(window).width() > 1240 ? $(".o-header").outerHeight() : $(".o-mobileHeader").outerHeight() + 200) + additionalOffset;
        $("html, body").animate(
          {
            scrollTop: $target.offset().top - offset,
          },
          500
        );
      }
    }
  }

  // Captures click events of all <a> elements with href starting with #
  $(document).on("click", 'a[href^="#"]', function () {
    // Click events are captured before hashchanges. Timeout
    // causes offsetAnchor to be called after the page jump.
    window.setTimeout(function () {
      offsetAnchor();
    }, 0);
  });

  // Set the offset when entering page with hash present in the url
  window.setTimeout(offsetAnchor, 0);

  // Apply the offset when the hash changes
  $(window).on("hashchange", function () {
    offsetAnchor();
  });
}
